import type { MessageToRenderer } from "../../../renderer/src/message/types";

declare global {
	interface HTMLWebViewElement {
		postMessage(message: MessageToRenderer): void;
	}
}

function postToRenderer(messages: MessageToRenderer[]) {
	const webview = document.getElementById("renderer") as HTMLWebViewElement;
	messages.forEach((message) => {
		webview.postMessage(message);
	});
}

export { postToRenderer };
